<app-error-page [errorStatus]="errorStatus">
  <app-error-page-title>
    {{ 'ERROR.404_PAGE.TITLE' | translate }}
  </app-error-page-title>
  <app-error-page-message>
      {{ 'ERROR.404_PAGE.MESSAGE' | translate }}
  </app-error-page-message>
  <app-error-page-action>
    <button
      mm-button
      class="not-found__action"
      homepageLink
      color="primary"
      size="large"
    >
      {{ 'ERROR.404_PAGE.BUTTON_LABEL' | translate }}
    </button>
  </app-error-page-action>
</app-error-page>
